// @ts-nocheck
/** 同步系统时间 */
import { getSystemTimeStamp } from '@/api/monitor';

// 本地时间和服务器时间差值
let localTimeDiffValue = 0;

const NativeDate = Date;

class CalibrationDate extends Date {
  constructor(...args) {
    if (args.length) {
      // 传参 取原始参数
      super(...args);
    } else {
      // 没有参数 取当前时间
      super(CalibrationDate.now());
    }
  }
}

CalibrationDate.now = () => {
  return NativeDate.now() + localTimeDiffValue;
};

window.NativeDate = NativeDate;
window.Date = CalibrationDate;

export const automaticTimeCorrection = () => {
  getSystemTimeStamp().then((res) => {
    if (res && res.data) {
      localTimeDiffValue = res.data - NativeDate.now();
      console.warn(localTimeDiffValue);
    }
  });
};
